import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  icon40: {
    fontSize: 40,
  },
  icon48: {
    fontSize: 48,
  },
  icon72: {
    fontSize: 72,
  },
  icon80: {
    fontSize: 80,
  },
}));
